import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  Theme01: {
    path: `${baseRoutes.userBaseRoutes}theme01`,
  },
};

export default accessRoute;
